import map from 'lodash/map'
import React from 'react'

import { Background } from '@Components/Background'
import { BlockContainer } from '@Components/BlockContainer'
import { CommonContent } from '@Components/CommonContent'
import { RTEContent } from '@Components/RTEContent'
import { HeaderWithTextLineItem } from '@CoreComponents/TextFields/HeaderWithTextLineItem'
import { Block, ReferenceContentFragment, UspBlock } from '@Generated/graphql'
import { getLinkData, parseExtraColors } from '@Globals/CMS/FieldHelpers'
import { pageTypeToDestinationPageType } from '@Globals/Page/Mappers'

import styles from './USP.module.scss'

const USPBlock = ({
  data,
  id,
}: {
  data: Block & UspBlock
  id?: string
}) => {
  const { appearance, common } = data
  const extraColors = parseExtraColors(appearance?.extraColors, ['border'])

  if (!data.items || data.items.length === 0) {
    return null
  }

  return (
    <BlockContainer
      appearance={appearance || {}}
      common={{}}
      id={id}
    >
      <div className={styles.inner}>
        <div className={styles.left}>
          <div className={styles.common}>
            <CommonContent common={common || {}} />
          </div>
          <div className={styles.list}>
            {map(data.items, (item) => {
              const linkData = getLinkData(item.link)
              return (
                <HeaderWithTextLineItem
                  analytics={{
                    dest_page_type: pageTypeToDestinationPageType(linkData.type),
                    dest_page_type_id: linkData.id,
                  }}
                  borderColor={extraColors.border}
                  header={item.title}
                  href={item.link?.url || undefined}
                  label={item.linkTitle || linkData.title || null}
                  textColor={appearance?.textColor || undefined}
                >
                  <RTEContent data={item.text} />
                </HeaderWithTextLineItem>
              )
            })}
          </div>
        </div>
        <div className={styles.asset}>
          {'asset' in data && (
            <Background asset={data.asset as ReferenceContentFragment} className={styles.assetBackground} />
          )}
        </div>
      </div>
    </BlockContainer>
  )
}

export default USPBlock
